import React from "react";

const NeueHighlightStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.25 15.25L17.25 5.75L14.25 2.75L4.75 10.75M9.25 15.25L2.75 17.25ZM9.25 15.25L4.75 10.75ZM2.75 17.25L4.75 10.75ZM2.75 17.25H17.25Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlight-stroke",
  d: "M9.25 15.25L17.25 5.75L14.25 2.75L4.75 10.75M9.25 15.25L2.75 17.25M9.25 15.25L4.75 10.75M4.75 10.75L2.75 17.25M2.75 17.25H17.25",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueHighlightStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;